import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
export default defineComponent({
    name: 'product-headline',
    computed: Object.assign({}, mapGetters('blue', {
        currentProduct: 'currentProduct',
    })),
});
